var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-info" }, [
    _vm.titleImage
      ? _c("img", {
          staticClass: "product-info__title-image",
          attrs: { src: _vm.titleImage, alt: _vm.product.title }
        })
      : _vm._e(),
    _c(
      "h1",
      {
        staticClass: "product-info__title",
        class: _vm.titleImage ? "u-sr-only" : ""
      },
      [_vm._v(_vm._s(_vm.product.title))]
    ),
    _c("div", { staticClass: "product-info__type-antioxidants" }, [
      _vm.product.customFields.flavor_type
        ? _c("div", { staticClass: "product-info__type-antioxidant" }, [
            _c(
              "div",
              { staticClass: "product-info__icon" },
              [_c("icon", { attrs: { name: "leaf", size: "18px" } })],
              1
            ),
            _c("span", { staticClass: "product-info__icon-text" }, [
              _vm._v(_vm._s(_vm.product.customFields.flavor_type))
            ])
          ])
        : _vm._e(),
      _vm.product.customFields.antioxidants
        ? _c("div", { staticClass: "product-info__type-antioxidant" }, [
            _c(
              "div",
              { staticClass: "product-info__icon" },
              [_c("icon", { attrs: { name: "antioxidant", size: "18px" } })],
              1
            ),
            _c("span", { staticClass: "product-info__icon-text" }, [
              _vm._v(
                _vm._s(_vm.product.customFields.antioxidants) +
                  "mg Antioxidants"
              )
            ])
          ])
        : _vm._e()
    ]),
    _vm.product.description
      ? _c("div", {
          staticClass: "product-info__description",
          domProps: { innerHTML: _vm._s(_vm.product.description) }
        })
      : _vm._e(),
    _c("svg", { staticClass: "product-info__properties" }, [
      _c("use", {
        attrs: {
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          href: "#properties"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }